import { Input } from "reactstrap";
import { useState } from "react";
import {
  Button,
  Modal,
  Table
} from "react-bootstrap";

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'MAD',
});

const format = (price) => formatter.format(price)

export const ConfirmProductsBoxModal = ({show, productsBoxes, handleClose, handleClick}) => {
  const [title, setTitle] = useState("");

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Qrcodes quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table id="invoice">
            <thead>
              <tr>
                <th className="border-0">Id</th>
                <th className="border-0">Name</th>
                <th className="border-0">Price</th>
                <th className="border-0">QrCodes Quantity</th>
              </tr>
            </thead>
            <tbody>
              {productsBoxes.map((box, index) => {
                let product = box.product;
                if (box.checked && box.qrCodesQuantity > 0)
                  return (
                    <tr key={index}>
                      <td>{box.id}</td>
                      <td>{product.name}</td>
                      <td>{format(product.price)}</td>
                      <td>{box.qrCodesQuantity}</td>
                    </tr>
                  );
              })}
            </tbody>
          </Table>
          <label htmlFor="name">Name</label>
          <Input value={title} onChange={(e) => {
              setTitle(e.target.value);
            }}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={() => handleClick(title)}>Generate qrcodes</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
